const cardItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20illustration%20of%20a%20couple%20sharing%20earbuds%20in%20a%20cafe%2C%20soft%20warm%20lighting%2C%20pastel%20coral%20and%20cream%20tones%2C%20clean%20art%20style%2C%20editorial%20quality&width=800&height=600&seq=card-01-romance&orientation=landscape',
    tag: '恋爱',
    title: '《心动频率》· 甜宠天花板',
    desc: '高冷社长与实习生的办公室秘密恋爱，每周三更新，甜蜜指数爆表，已连续8周霸占人气榜首。',
    time: '今日更新',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20illustration%20of%20a%20warrior%20with%20magical%20sword%20in%20an%20epic%20landscape%2C%20dramatic%20golden%20and%20coral%20lighting%2C%20clean%20modern%20art%20style%2C%20editorial%20quality&width=800&height=600&seq=card-02-fantasy&orientation=landscape',
    tag: '奇幻',
    title: '《剑与魔法》· 异世界冒险',
    desc: '普通高中生穿越到魔法大陆，凭借现代知识在异世界闯出一片天地。画风精美，战斗场面燃爆。',
    time: '2小时前更新',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20alley%20with%20mysterious%20shadows%2C%20moody%20atmosphere%2C%20warm%20accent%20lighting%2C%20clean%20art%20style%2C%20cinematic%20composition&width=800&height=600&seq=card-03-suspense&orientation=landscape',
    tag: '悬疑',
    title: '《第七个夜晚》· 烧脑神作',
    desc: '连环案件背后的惊天秘密，每一话都充满反转。读者评分9.6，被誉为年度最佳悬疑韩漫。',
    time: '昨日更新',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20students%20in%20a%20university%20campus%20during%20cherry%20blossom%20season%2C%20fresh%20youthful%20aesthetic%2C%20soft%20coral%20and%20peach%20tones%2C%20clean%20art%20style&width=800&height=600&seq=card-04-campus&orientation=landscape',
    tag: '校园',
    title: '《樱花季的约定》· 青春治愈',
    desc: '大学校园里的温暖故事，从陌生到熟悉的四人之旅。画风清新治愈，被誉为韩漫界的"请回答"系列。',
    time: '3小时前更新',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20illustration%20of%20a%20confident%20woman%20in%20a%20luxury%20office%20setting%2C%20powerful%20pose%2C%20warm%20golden%20and%20coral%20lighting%2C%20clean%20modern%20art%20style%2C%20editorial%20quality&width=800&height=600&seq=card-05-revenge&orientation=landscape',
    tag: '励志',
    title: '《她的反击》· 逆袭爽文',
    desc: '被背叛的女主角重获新生，一步步走上人生巅峰。节奏紧凑、爽感十足，让人根本停不下来。',
    time: '今日更新',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            编辑团队每日精选高分韩漫，为你推荐不容错过的精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/11] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-flex px-2.5 py-1 bg-accent-500/90 backdrop-blur-sm text-background-50 text-[10px] font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
                <div className="flex items-center gap-1.5 mt-3 pt-3 border-t border-background-200/50">
                  <i className="ri-time-line text-[10px] text-foreground-500"></i>
                  <span className="text-[10px] text-foreground-500">{item.time}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}